module.exports = __webpack_public_path__ + "img/ke_customer_service_image.8e5a05f.png";